import * as React from 'react';

function IconLanguageEnSmall(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <mask
        id="language-en-small-mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={24}
      >
        <rect width={24} height={24} rx={4} fill="#C4C4C4" />
      </mask>
      <g mask="url(#language-en-small-mask0)">
        <path
          d="M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z"
          fill="#F0F5FF"
        />
        <path d="M24 3H0V6H24V3Z" fill="#FF564E" />
        <path d="M24 9H0V12H24V9Z" fill="#FF564E" />
        <path d="M24 15H0V18H24V15Z" fill="#FF564E" />
        <path d="M24 21H0V24H24V21Z" fill="#FF564E" />
        <path d="M17.9649 0H0V12.898H17.9649V0Z" fill="#0060CF" />
      </g>
      <g clipPath="url(#language-en-small-clip0)">
        <path
          d="M6.73413 4.93555L6.46972 5.74896H5.6145L6.30652 6.25141L6.04211 7.06475L6.73413 6.5623L7.42569 7.06475L7.16135 6.25141L7.85337 5.74896H6.99808L6.73413 4.93555Z"
          fill="white"
        />
        <path
          d="M6.99808 8.6842L6.73413 7.87085L6.46972 8.6842H5.6145L6.30652 9.18671L6.04211 10.0001L6.73413 9.49754L7.42569 10.0001L7.16135 9.18671L7.85337 8.6842H6.99808Z"
          fill="white"
        />
        <path
          d="M3.38364 8.6842L3.11962 7.87085L2.85522 8.6842H2L2.69201 9.18671L2.42761 10.0001L3.11962 9.49754L3.81125 10.0001L3.54692 9.18671L4.2388 8.6842H3.38364Z"
          fill="white"
        />
        <path
          d="M3.11962 4.93555L2.85522 5.74896H2L2.69201 6.25141L2.42761 7.06475L3.11962 6.5623L3.81125 7.06475L3.54692 6.25141L4.2388 5.74896H3.38364L3.11962 4.93555Z"
          fill="white"
        />
        <path
          d="M6.73413 2L6.46972 2.81347H5.6145L6.30652 3.31599L6.04211 4.12933L6.73413 3.62682L7.42569 4.12933L7.16135 3.31599L7.85337 2.81347H6.99808L6.73413 2Z"
          fill="white"
        />
        <path
          d="M3.11962 2L2.85522 2.81347H2L2.69201 3.31599L2.42761 4.12933L3.11962 3.62682L3.81125 4.12933L3.54692 3.31599L4.2388 2.81347H3.38364L3.11962 2Z"
          fill="white"
        />
        <path
          d="M10.3483 4.93555L10.084 5.74896H9.22876L9.92071 6.25141L9.65643 7.06475L10.3483 6.5623L11.04 7.06475L10.7756 6.25141L11.4676 5.74896H10.6124L10.3483 4.93555Z"
          fill="white"
        />
        <path
          d="M10.6124 8.6842L10.3483 7.87085L10.084 8.6842H9.22876L9.92071 9.18671L9.65643 10.0001L10.3483 9.49754L11.04 10.0001L10.7756 9.18671L11.4676 8.6842H10.6124Z"
          fill="white"
        />
        <path
          d="M14.2268 8.6842L13.9628 7.87085L13.6984 8.6842H12.8433L13.5351 9.18671L13.2708 10.0001L13.9628 9.49754L14.6544 10.0001L14.39 9.18671L15.0821 8.6842H14.2268Z"
          fill="white"
        />
        <path
          d="M13.9628 4.93555L13.6984 5.74896H12.8433L13.5351 6.25141L13.2708 7.06475L13.9628 6.5623L14.6544 7.06475L14.39 6.25141L15.0821 5.74896H14.2268L13.9628 4.93555Z"
          fill="white"
        />
        <path
          d="M10.3483 2L10.084 2.81347H9.22876L9.92071 3.31599L9.65643 4.12933L10.3483 3.62682L11.04 4.12933L10.7756 3.31599L11.4676 2.81347H10.6124L10.3483 2Z"
          fill="white"
        />
        <path
          d="M13.9628 2L13.6984 2.81347H12.8433L13.5351 3.31599L13.2708 4.12933L13.9628 3.62682L14.6544 4.12933L14.39 3.31599L15.0821 2.81347H14.2268L13.9628 2Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="language-en-small-clip0">
          <rect
            width={13.0821}
            height={8}
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default IconLanguageEnSmall;
